import client from './client';

// 简历筛选提交数据类型
// 下一环节与负责人已改由 HR 在「待分配」环节指定，这里不再提交
export interface ResumeScreeningData {
  result: '通过' | '不通过';
  comments?: string;
  rejection_reason?: string | null;
}

// 处理简历筛选
export const processResumeScreening = async (candidateId: number, data: ResumeScreeningData) => {
  const response = await client.post(`/stage-flow/resume-screening/${candidateId}`, data);
  return response.data;
};

// 面试流程提交数据类型
export interface InterviewData {
  result: '通过' | '不通过';
  score?: number;
  evaluation?: string;
  rejection_reason?: string | null;
}

// 处理面试流程
export const processInterview = async (candidateId: number, data: InterviewData) => {
  const response = await client.post(`/stage-flow/interview/${candidateId}`, data);
  return response.data;
};

// HR 分配下一环节（处理「待分配」待办）
export interface AssignNextStageData {
  next_stage: '一面' | '二面' | '三面' | '谈薪&背调';
  next_owner_id: number;
  interview_mode?: '线上' | '线下' | null;
  scheduled_time?: string | null;
  interview_location?: string | null;
  interview_traffic_guide?: string | null;
  send_invitation_email?: boolean;
  comments?: string | null;
}

export interface AssignNextStageResult {
  candidate_id: number;
  source_stage: string;
  current_stage: string;
  next_owner_name: string;
  invitation_sent: boolean;
  /** 邀约邮件发送失败原因（发送成功或未勾选发送时为 null） */
  invitation_error?: string | null;
  message: string;
}

export const assignNextStage = async (
  candidateId: number,
  data: AssignNextStageData
): Promise<AssignNextStageResult> => {
  const response = await client.post(`/stage-flow/assign/${candidateId}`, data);
  // client 的响应拦截器已把 code:200 的响应解包为内层 data，此处不能再取一层 .data
  return response.data;
};

// 终止流程数据类型
export interface TerminateData {
  reason: string;
}

// 终止流程
export const terminateProcess = async (candidateId: number, data: TerminateData) => {
  const response = await client.post(`/stage-flow/terminate/${candidateId}`, data);
  return response.data;
};

// HR异常终止流程
export const hrTerminateProcess = async (candidateId: number, termination_reason: string) => {
  const response = await client.post(`/stage-flow/hr-terminate/${candidateId}`, { termination_reason });
  return response.data;
};

// HR批量异常终止流程
export interface BatchTerminateResult {
  success_count: number;
  failed_count: number;
  success_ids: number[];
  failed: { candidate_id: number; candidate_name: string | null; reason: string }[];
  message: string;
}

export const batchHrTerminateProcess = async (
  candidateIds: number[],
  termination_reason: string
): Promise<BatchTerminateResult> => {
  const response = await client.post('/stage-flow/batch-hr-terminate', {
    candidate_ids: candidateIds,
    termination_reason,
  });
  // client 的响应拦截器已把 code:200 的响应解包为内层 data，此处不能再取一层 .data
  return response.data;
};

// 终止流程回退
export const rollbackTerminatedCandidate = async (candidateId: number) => {
  const response = await client.post(`/stage-flow/rollback-terminated/${candidateId}`);
  return response.data;
};

// 查询异常终止信息
export const getTerminationInfo = async (candidateId: number) => {
  const response = await client.get(`/stage-flow/termination-info/${candidateId}`);
  return response.data;
};

// 待办转交
export const transferTodo = async (candidate_id: number, new_owner_id: number, target_stage?: string) => {
  const response = await client.post('/todo/transfer', { candidate_id, new_owner_id, target_stage });
  return response.data;
};
